import { CustomerMethodologyPage } from "../../components/CustomerMethodologyPage";

export function RegulatoryAiMethodology() {
  return (
    <CustomerMethodologyPage
      title="Regulatory reference AI — overview"
      description="How WeConsult Rx helps consultant pharmacists search regulatory text with cited answers."
      path="/trust/regulatory-ai-methodology"
    >
      <p>
        The regulatory reference assistant helps consultant pharmacists find
        answers in HIPAA, DEA, CMS, and state regulatory text — with exact
        quotes and citations so you can verify every answer.
      </p>
      <h2>What it covers</h2>
      <ul>
        <li>Multi-source regulatory corpus (HIPAA, DEA, CMS SNF/ASC/dialysis, state boards).</li>
        <li>Answers include verbatim quotes from the source document.</li>
        <li>Source filtering by regulatory body and jurisdiction.</li>
      </ul>
      <h2>How it helps</h2>
      <p>
        During chart review or survey prep, pharmacists can quickly locate the
        regulatory basis for a requirement — without reading hundreds of pages
        of CFR or state code.
      </p>
    </CustomerMethodologyPage>
  );
}
